export const SUPABASE_STORAGE_URL = 'https://hmseykssvtyrihuxymeo.supabase.co/storage/v1/object/public/bbt';

export const LAYER_IMAGES = {
  backgrounds: {
    milky_way: `${SUPABASE_STORAGE_URL}/character-layers/backgrounds/blue.png`,
    andromeda: `${SUPABASE_STORAGE_URL}/character-layers/backgrounds/red.png`,
  },
  skins: {
    eclipse: '/image/character/eclipse.png',
    nova: '/image/character/nova.png',
    pulsar: '/image/character/pulsar.png',
    nebula: '/image/character/nebula.png',
    void: '/image/character/void.png',
  },
  gameElements: {
    bubble: `${SUPABASE_STORAGE_URL}/game_elements/bubble.png`,
    bubbleAll: `${SUPABASE_STORAGE_URL}/game_elements/bubble_all.png`,
  },
  factionCardBackgrounds: {
    milky_way: `${SUPABASE_STORAGE_URL}/story/dragonvsphoenix_03.png`,
    andromeda: `${SUPABASE_STORAGE_URL}/story/phoenix_01.jpg`,
  },
  eyes: {
    default: `${SUPABASE_STORAGE_URL}/character-layers/eyes/default_eyes.png`,
  },
  outfits: {
    default: `${SUPABASE_STORAGE_URL}/character-layers/outfits/default_outfit.png`,
  },
  frames: {
    sirians: `${SUPABASE_STORAGE_URL}/character-layers/frames/sirians.png`,
    vegans: `${SUPABASE_STORAGE_URL}/character-layers/frames/vegans.png`,
    antareans: `${SUPABASE_STORAGE_URL}/character-layers/frames/antareans.png`,
    devils: `${SUPABASE_STORAGE_URL}/character-layers/frames/devils.png`,
  },
  planets: {
    earth: `${SUPABASE_STORAGE_URL}/game_elements/dragonvsphoenix.png`,
    dragonvsphoenix: `${SUPABASE_STORAGE_URL}/story/dragonvsphoenix_03.png`,
    dragon: `${SUPABASE_STORAGE_URL}/story/dragon_02.jpg`,
    phoenix: `${SUPABASE_STORAGE_URL}/story/phoenix_01.jpg`,
    venus: `${SUPABASE_STORAGE_URL}/character-layers/planet/venus.png`,
    uranus: `${SUPABASE_STORAGE_URL}/character-layers/planet/uranus.png`,
    saturn: `${SUPABASE_STORAGE_URL}/character-layers/planet/saturn.png`,
    mars: `${SUPABASE_STORAGE_URL}/character-layers/planet/mars.png`,
  }
};

export const STORY_MEDIA = {
  dragonVsPhoenixClip: `${SUPABASE_STORAGE_URL}/story/dragonvsphoenix_01.mp4`,
};

export const RACE_CONFIG = {
  SIRIANS: {
    name: 'SIRIANS',
    displayName: '天狼族',
    planetImage: LAYER_IMAGES.planets.venus,
    frameImage: LAYER_IMAGES.frames.sirians,
  },
  VEGANS: {
    name: 'VEGANS',
    displayName: '織女族',
    planetImage: LAYER_IMAGES.planets.uranus,
    frameImage: LAYER_IMAGES.frames.vegans,
  },
  ANTAREANS: {
    name: 'ANTAREANS',
    displayName: '心宿族',
    planetImage: LAYER_IMAGES.planets.saturn,
    frameImage: LAYER_IMAGES.frames.antareans,
  },
  DEVILS: {
    name: 'DEVILS',
    displayName: '魔族',
    planetImage: LAYER_IMAGES.planets.mars,
    frameImage: LAYER_IMAGES.frames.devils,
  },
};

export const COLOR_CONFIG = {
  eclipse: {
    name: 'eclipse',
    displayName: 'Eclipse',
    skinImage: LAYER_IMAGES.skins.eclipse,
    hexCode: '#1a1a1a',
  },
  nova: {
    name: 'nova',
    displayName: 'Nova',
    skinImage: LAYER_IMAGES.skins.nova,
    hexCode: '#f5f5f5',
  },
  pulsar: {
    name: 'pulsar',
    displayName: 'Pulsar',
    skinImage: LAYER_IMAGES.skins.pulsar,
    hexCode: '#3b82f6',
  },
  nebula: {
    name: 'nebula',
    displayName: 'Nebula',
    skinImage: LAYER_IMAGES.skins.nebula,
    hexCode: '#10b981',
  },
  void: {
    name: 'void',
    displayName: 'Void',
    skinImage: LAYER_IMAGES.skins.void,
    hexCode: '#ef4444',
  },
};

export const FACTION_CONFIG = {
  milky_way: {
    name: 'milky_way',
    displayName: '銀河系',
    backgroundImage: LAYER_IMAGES.backgrounds.milky_way,
    cardBackgroundImage: LAYER_IMAGES.factionCardBackgrounds.milky_way,
  },
  andromeda: {
    name: 'andromeda',
    displayName: '仙女座',
    backgroundImage: LAYER_IMAGES.backgrounds.andromeda,
    cardBackgroundImage: LAYER_IMAGES.factionCardBackgrounds.andromeda,
  },
};

export const INITIAL_SKILL_POINTS = 50;

// 泡泡值系統常量（消耗資源系統）
export const BUBBLE_THRESHOLDS = {
  CRITICAL: 50,    // 派遣挖礦最低需求
  WARNING: 80,     // 警告閾值
  NORMAL: 100,     // 正常狀態
  EXCELLENT: 120,  // 優秀狀態
};

export const BUBBLE_COLORS = {
  CRITICAL: '#ef4444',     // 紅色 - 危險
  WARNING: '#f59e0b',      // 橙色 - 警告
  NORMAL: '#3b82f6',       // 藍色 - 正常
  EXCELLENT: '#06b6d4',    // 青色 - 優秀
  BURST: '#8b5cf6',        // 紫色 - 爆發
};

export const BUBBLE_STATUS_TEXT = {
  CRITICAL: '不足',
  WARNING: '偏低',
  NORMAL: '正常',
  EXCELLENT: '充盈',
};

// 甜度屬性系統常量（保留給屬性系統使用）
export const SWEETNESS_THRESHOLDS = {
  DANGER: 80,
  NORMAL: 100,
};

export const SWEETNESS_COLORS = {
  DANGER: '#ef4444',
  NORMAL: '#10b981',
  BURST: '#f472b6',
};

export const STAT_MAX_VALUES = {
  NORMAL_RACE: 2000,
  DEVIL_RACE: 2500,
};
